import Client from '@/hexapla-core/client'
import { Domain } from '@/hexapla-core/domains'
import { Witness } from '@/hexapla-core/domains/resources'

export interface WitnessService extends Domain<Witness> {
  index: (url: string) => Promise<Witness[]>
  byWitnessType: (url: string, witnessTypeID: number) => Promise<Witness[]>
  show: (url: string, id: string | number) => Promise<Witness>
  create: (url: string, witness: Witness) => Promise<Witness>
  update: (url: string, witness: Witness) => Promise<Witness>
  destroy: (url: string, id: string | number) => Promise<void>
}

export const index = (url: string): Promise<Witness[]> =>
  Client.get<Witness[]>(`${url}/api/witnesses`)

export const byWitnessType = (url: string, witnessesTypeID = 0): Promise<Witness[]> => {
  const query = witnessesTypeID ? `?witness_type_id=${witnessesTypeID}` : ''

  return Client.get<Witness[]>(`${url}/api/witnesses${query}`)
}

export const show = (url: string, witID: string | number): Promise<Witness> =>
  Client.get<Witness>(`${url}/api/witnesses/${witID}`)

export const create = (url: string, witness: Witness): Promise<Witness> =>
  Client.post<Witness, Witness>(`${url}/api/witnesses`, witness)

export const update = (url: string, witness: Witness): Promise<Witness> =>
  Client.patch<Witness, Witness>(`${url}/api/witnesses/${witness.id}`, witness)

export const destroy = (url: string, witID: string | number): Promise<void> =>
  Client.destroy<void>(`${url}/api/admin/witnesses/${witID}`)

export default {
  index,
  show,
  byWitnessType,
  create,
  update,
  destroy,
} as WitnessService
